import { makeStyles } from '@rbx/ui';
import {
  assistantIsMobileBreakpoint,
  assistantMaxWidth,
} from '../constants/assistantStyleConstants';

export const assistantInputPaddingBottom = 3;

const useAssistantInputStyles = makeStyles()((theme) => {
  return {
    container: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      background: theme.palette.surface[0],
      paddingTop: theme.spacing(2),
      textAlign: 'center',
      [theme.breakpoints.down('Large')]: {
        padding: theme.spacing(2, 4, 0),
      },
      [theme.breakpoints.down(assistantMaxWidth)]: {
        padding: theme.spacing(2, 2, 0),
      },
      '& > *': {
        maxWidth: assistantMaxWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    textField: {
      textAlign: 'left',
      maxWidth: assistantMaxWidth,
      margin: '0 auto',
      '& .Mui-focused fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.actionV2.primaryBrand.fill,
      },
      '& .Mui-focused.MuiFormLabel-root': {
        fontWeight: 400,
      },
    },
    helperTextWrapper: {
      [theme.breakpoints.down('Medium')]: {
        margin: 0,
      },
    },
    helperText: {
      display: 'block',
      textAlign: 'center',
      padding: theme.spacing(1, 2),
      [theme.breakpoints.down(assistantIsMobileBreakpoint)]: {
        padding: theme.spacing(1, 2, 1.5),
      },
      [theme.breakpoints.down('Medium')]: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    mobileSendButton: {
      minWidth: 0,
      height: 32,
      width: 32,
      padding: 4,
      borderRadius: 8,
    },
    desktopSendButton: {
      display: 'flex',
      alignItems: 'center',
    },
    inputContainer: {
      padding: theme.spacing(2, 0, 2, 2),
      '& textarea': {
        paddingRight: theme.spacing(14),
      },
    },
    inputButtonWrapper: {
      position: 'absolute',
      top: 0,
      right: 0,
      padding: theme.spacing(3.5, 2),
    },
    stopIcon: {
      width: 12,
      height: 12,
      backgroundColor: theme.palette.states.active,
      borderRadius: 2,
      marginRight: theme.spacing(1),
      [theme.breakpoints.down(assistantIsMobileBreakpoint)]: {
        margin: 0,
      },
    },
  };
});

export default useAssistantInputStyles;
